import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { FieldWrapper } from '@ngx-formly/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'formly-input-wrapper',
  imports: [TooltipModule, IconV3Component],
  template: `
    <div class="formly-input-wrapper">
      <div class="input-container">
        <div class="field-container">
          <ng-container #fieldComponent></ng-container>
        </div>
        <span class="info-icon" [style.visibility]="props['infoText'] ? 'visible' : 'hidden'">
          <geaui-icon-v3
            file="24px_c-info"
            pTooltip="{{ props['infoText'] }}"
            tooltipStyleClass="p-tooltip-light-blue"></geaui-icon-v3>
        </span>
      </div>

      <div class="error-text flex gap-2">
        @if (props['errorMessage']) {
          Invalid Input
          <geaui-icon-v3 file="16px_c-info" color="cancel-red" pTooltip="{{ props['errorMessage'] }}"></geaui-icon-v3>
        }
      </div>
    </div>
  `,
  styles: [
    `
      .formly-input-wrapper {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
      }
      .input-container {
        display: flex;
        align-items: center;
        width: 100%;
      }
      .field-container {
        flex: 1;
      }
      .info-icon {
        margin-left: 8px;
        cursor: pointer;
        font-size: 1.25rem;
        color: #007bff;
      }
      .error-text {
        margin-top: -1.25rem;
        color: red;
        font-size: 0.75rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputWrapperComponent extends FieldWrapper {
  override get props() {
    return this.field.props || {};
  }
}
